// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { GridApi } from '@mui/x-data-grid-pro';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { MutableRefObject, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface UseDemandDataGridProps {
  apiRef: MutableRefObject<GridApi>;
}

export const useDemandDataGrid = ({ apiRef }: UseDemandDataGridProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'DemandDataGrid.error' });
  const { enqueueErrorSnackbar } = useCustomSnackbar();

  const contextValue: DemandGridContext = useMemo(
    () => ({}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t],
  );

  return {
    contextValue,
  };
};
